import React, { useState } from "react";

import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import InsuranceBreakDownMainPage from "./InsuranceBreakDownMainPage";
import InsuranceBreakDownDetails from "./InsuranceBreakDownDetails";

export default function InsuranceBreakDown() {
  const [selectedBreakdown, setSelectedBreakdown] = useState(null);
  const [summaryOfSelectedBreakdown, setSummaryOfSelectedBreakdown] = useState([]);

  return (
    <React.Fragment>
      <DashboardLayout>
        {selectedBreakdown === null ? (
          <InsuranceBreakDownMainPage
            setSelectedBreakdown={setSelectedBreakdown}
            selectedBreakdown={selectedBreakdown}
            setSummaryOfSelectedBreakdown={setSummaryOfSelectedBreakdown}
          />
        ) : (
          <InsuranceBreakDownDetails
            setSelectedBreakdown={setSelectedBreakdown}
            selectedBreakdown={selectedBreakdown}
            summaryOfSelectedBreakdown={summaryOfSelectedBreakdown}
            setSummaryOfSelectedBreakdown={setSummaryOfSelectedBreakdown}
          />
        )}
      </DashboardLayout>
    </React.Fragment>
  );
}
